import type { Story } from '@/types/stories'

export const stories: Story[] = [
  {
    title: 'From Student to Entrepreneur',
    quote:
      'The mentorship and guidance I received through IBON World helped me refine my business idea, connect with industry professionals, and gain the confidence to pursue entrepreneurship full-time.',
    author: 'TUWE Participant',
  },
  {
    title: 'Building Connections Across Continents',
    quote:
      'AfCaSPIH introduced me to students and innovators from different countries. The relationships I built expanded my perspective and created opportunities I would never have accessed on my own.',
    author: 'AfCaSPIH Participant',
  },
  {
    title: 'A Campaign That Mobilised Support',
    quote:
      'The Out of Lebanon Campaign demonstrated how advocacy, collaboration, and public engagement can help bring attention to urgent humanitarian issues.',
    author: 'Campaign Stakeholder',
  },
]
